import Link from 'next/link';
import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';

import { Box } from '../Box';
import { LegacyButton } from '../LegacyButton';
import { NextImageWithLoader } from '../NextImageWithLoader';

import { ReactComponent as Location } from '@/assets/icons/address.svg';
import { ReactComponent as Calendar } from '@/assets/icons/calendar.svg';
import { ReactComponent as Phone } from '@/assets/icons/phone-outline.svg';
export const BoutiqueWrapper = styled(Flex)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
  ${({ theme }) => css`
    @media (max-width: ${theme.breakpoints.sm}) {
      flex-wrap: nowrap;
      max-width: 100vw;
      overflow: hidden;
    }
  `}
`;

export const Boutique = styled(Flex)`
  flex: 1;
  padding: 24px 32px;
  height: 100%;
  min-height: 469px;
  flex-direction: column;
  justify-content: space-between;
  &:last-child {
    margin-right: 0;
  }

  ${({ theme }) => css`
    background: ${theme.colors.primary};
    margin-right: ${theme.spacing(2)};
    max-width: 100vw;
    @media (min-width: ${theme.breakpoints.sm}) {
      flex-wrap: nowrap;
      overflow: hidden;
      display: flex;
      margin-right: 12px;
      align-items: center;
    }
  `}
`;
export const BoutiqueTopInfo = styled(Flex)`
  flex-direction: column;
  width: 100%;
  align-items: start;

  ${({ theme }) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
      align-items: center;
    }
  `}
`;
export const BoutiqueCTA = styled(Flex)`
  align-items: start;
  flex-direction: column;
  width: 100%;
  ${({ theme }) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
      align-items: center;
    }
  `}
`;

export const BoutiqueMobile = styled(Flex)`
  padding: 24px 16px;
  height: 100%;
  min-height: 261px;
  min-width: 240px;
  align-items: start;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  &:last-child {
    margin-right: 0;
  }
  ${({ theme }) => css`
    background: ${theme.colors.primary};
    margin-right: ${theme.spacing(2)};
    @media (min-width: ${theme.breakpoints.sm}) {
      flex-wrap: nowrap;
      max-width: 100vw;
      overflow: hidden;
    }
  `}
`;
export const BoutiqueTitle = styled(Flex)`
  ${({ theme }) => css`
    font-size: ${theme.spacing(2)};
    text-align: left;
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
    margin-bottom: ${theme.spacing(1)};
    @media (min-width: ${theme.breakpoints.sm}) {
      flex-wrap: nowrap;
      max-width: 100vw;
      font-size: ${theme.fontSizes.h4};
      overflow: hidden;
      text-align: center;
    }
  `}
`;

export const Info = styled(Flex)`
  ${({ theme }) => css`
    font-size: ${theme.spacing(1.5)};
    text-align: left;
    font-weight: ${theme.fontWeights.regular};
    font-family: ${theme.fontFamilies.italianPlate};
    margin-bottom: 0;
    margin-left: ${theme.spacing(1)};
    line-height: ${theme.spacing(2)};
    @media (min-width: ${theme.breakpoints.sm}) {
      text-align: center;
      margin-left: 0;
      font-size: ${theme.fontSizes.p0};
      margin-bottom: ${theme.spacing(1)};
    }
  `}
`;
export const PhoneInfo = styled(Flex)`
  ${({ theme }) => css`
    font-size: ${theme.spacing(1.5)};
    text-align: left;
    font-weight: ${theme.fontWeights.regular};
    font-family: ${theme.fontFamilies.italianPlate};
    margin-bottom: 0;
    text-decoration: underline;
    margin-left: ${theme.spacing(1)};
    line-height: ${theme.spacing(2)};
    @media (min-width: ${theme.breakpoints.sm}) {
      text-align: center;
      margin-left: 0;
      font-size: ${theme.fontSizes.p0};
    }
  `}
`;

export const AdressBox = styled(Flex)`
  flex-direction: row;
  align-items: start;

  svg {
    flex-shrink: 0;
  }

  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(1)};
  `}
`;
export const InfoBox = styled(Flex)`
  flex-direction: row;
  align-items: center;
  &:first-child {
    align-items: start;
  }
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(1)};
  `}
`;
export const OpeningHoursTitle = styled(Flex)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h5};
    text-align: center;
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
    margin-top: ${theme.spacing(3)};
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const OpeningHourFlex = styled(Flex)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h5};
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
  `}
`;
export const WeekDay = styled(Flex)`
  text-align: left;
  line-height: 22px;
  width: 66px;
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    font-family: ${theme.fontFamilies.openSans};
    font-weight: ${theme.fontWeights.regular};
    margin-right: 0;
    @media (min-width: ${theme.breakpoints.sm}) {
      margin-right: ${theme.spacing(5)};
    }
  `}
`;
export const WeekDayInfo = styled(Flex)`
  text-align: left;
  line-height: 22px;
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    font-family: ${theme.fontFamilies.openSans};
    font-weight: ${theme.fontWeights.regular};
  `}
`;
export const BoutiqueBox = styled(Flex)`
  text-align: left;
  line-height: 17px;
  ${({ theme }) => css`
    gap: ${theme.spacing(3)};
    margin: ${theme.spacing(2, 0)};
    font-size: ${theme.fontSizes.p3};
    font-family: ${theme.fontFamilies.openSans};
    font-weight: ${theme.fontWeights.bold};

    ${theme.media.md.up} {
      gap: ${theme.spacing(4)};
    }
  `}
`;
export const CalendarIcon = styled(Calendar)`
  ${({ theme }) => css`
    height: ${theme.spacing(2)};
    width: ${theme.spacing(2)};
    g {
      fill: #111820;
    }
  `}
`;
export const BoutiqueButton = styled(LegacyButton)`
  text-transform: none;
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.p2};
    }
  `}
`;
export const Title = styled.div`
  text-align: left;
  line-height: 17px;
  text-decoration: underline;
  text-underline-offset: 5px;
  cursor: pointer;
  line-height: 1.1;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    font-family: ${theme.fontFamilies.openSans};
    font-weight: ${theme.fontWeights.bold};
  `}
`;
export const BoutiqueIcon = styled(Icon)`
  text-align: left;
  line-height: 17px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h4};
    font-family: ${theme.fontFamilies.openSans};
    font-weight: ${theme.fontWeights.bold};
    color: ${theme.colors.white};
  `}
`;

export const AppointmentButton = styled(LegacyButton)`
  text-align: center;
  text-transform: uppercase;
  width: 100%;
  padding: 12.5px 0;
  text-decoration: none;
  ${({ theme }) => css`
    color: ${theme.colors.black};
    background: ${theme.colors.white};
    font-family: ${theme.fontFamilies.openSans};
    margin-top: ${theme.spacing(2)};
    &:hover {
      color: ${theme.colors.primary};
    }
    @media (min-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.fontSizes.p3};
    }
  `}
`;

export const ImageEmptyWrapper = styled(Flex)<{ withBackground: boolean }>`
  width: 100%;
  flex: 1 1 0%;
  align-items: center;
  overflow: hidden;

  ${({ theme, withBackground }) => css`
    background: ${withBackground ? theme.colors.white : 'transparent'};
    padding: ${withBackground ? '25px 0' : 0};
    ${theme.media.md.up} {
      background: transparent;
      padding: 0;
    }
  `}
`;

export const Img = styled(NextImageWithLoader)<{
  $noStoreResults?: boolean;
  $scaleRatio?: number;
  $withBackground: boolean;
}>`
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1 1 0%;
  align-items: center;
  overflow: hidden;

  ${({ $withBackground, theme }) => css`
    background: ${$withBackground ? theme.colors.white : 'transparent'};

    ${theme.media.md.up} {
      background: transparent;
      padding: 0;
    }
  `}
  .next-image {
    width: 100%;
    ${({ $noStoreResults }) =>
      css`
        height: ${$noStoreResults && !!$noStoreResults ? '100%' : '245px'};
      `}
    // Put image to the background since scaled images takes the foreground.
    pointer-events: none;

    ${({ $scaleRatio }) =>
      $scaleRatio &&
      css`
        transform: scale(${$scaleRatio}) translateY(-${$scaleRatio * 2}%);
      `}
  }
`;

export const IntricateBoutiqueCard = styled(Flex)<{
  $placeholderStoresColor: string;
}>`
  flex: 1;
  min-height: 480px;
  align-items: center;
  flex-direction: column;
  &:last-child {
    margin-right: 0;
  }
  ${({ $placeholderStoresColor, theme }) => css`
    background: ${$placeholderStoresColor
      ? $placeholderStoresColor
      : theme.colors.secondaryLightGrey};
    margin-right: ${theme.spacing(2)};
    @media (min-width: ${theme.breakpoints.sm}) {
      flex-wrap: nowrap;
      max-width: 100vw;
      overflow: hidden;
      display: flex;
      height: 100%;
    }
  `}
`;

export const IntricateBoutiqueInfo = styled(Flex)`
  flex: 1;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  ${({ theme }) => css`
    margin-right: ${theme.spacing(2)};
  `}
`;

export const IntricateImage = styled(Box)`
  width: 100%;
  min-height: 245px;
  position: relative;
  img {
    object-fit: cover;
  }

  .error > img {
    position: absolute;
    top: 50%;
  }
`;

export const IntricateTitle = styled(Box)`
  ${({ theme }) => css`
    min-height: 19px;
    font-size: ${theme.spacing(2)};
    text-align: center;
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.secondary};
    display: flex;
    flex-direction: row;
    align-items: center;
    @media (min-width: ${theme.breakpoints.sm}) {
      min-height: 48px;
      flex-wrap: nowrap;
      max-width: 100vw;
      font-size: ${theme.fontSizes.h5};
      overflow: hidden;
      text-align: left;
    }
  `}
`;

export const IntricateInfoBox = styled(Flex)`
  width: 100%;
  height: 100%;
  ${({ theme }) => css`
    padding: ${theme.spacing(3, 1.25)};
    ${theme.media.sm.up} {
      padding: ${theme.spacing(2.5, 2)};
    }
  `}
`;

export const LocationIcon = styled(Location)`
  ${({ theme }) => css`
    & > path {
      fill: ${theme.colors.black};
    }
  `}
  width: 24px;
`;
export const PhoneIcon = styled(Phone)`
  width: 24px;
`;

export const IntricateAddressInfo = styled(Flex)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    text-align: left;
    font-weight: ${theme.fontWeights.regular};
    margin-bottom: 0;
    margin-left: ${theme.spacing(1)};
    line-height: ${theme.spacing(2.5)};
    color: ${theme.colors.secondary};

    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.p2};
    }
  `}
`;

export const IntricateIcon = styled(Icon)`
  text-align: left;
  line-height: 17px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h4};
    font-family: ${theme.fontFamilies.openSans};
    font-weight: ${theme.fontWeights.bold};
    color: ${theme.colors.primary};
  `}
`;

export const IntricateCTA = styled(Flex)`
  align-items: start;
  flex-direction: column;
  width: 100%;
`;

export const IntricateHoverTitle = styled.div`
  text-align: left;
  line-height: 17px;
  text-decoration: underline;
  text-underline-offset: 5px;
  cursor: pointer;
  line-height: 1.1;

  ${({ theme }) => css`
    color: ${theme.colors.navyBlueSub1};
    font-size: ${theme.fontSizes.p3};
    font-family: ${theme.fontFamilies.openSans};
    font-weight: ${theme.fontWeights.bold};
    &:hover {
      color: ${theme.colors.primary};
    }
  `}
`;

export const IntricateButton = styled(LegacyButton)`
  text-align: center;
  text-transform: uppercase;
  width: 100%;
  padding: 12.5px 0;
  text-decoration: none;
  ${({ theme }) => css`
    color: ${theme.colors.navyBlueSub1};
    background: ${theme.colors.white};
    font-family: ${theme.fontFamilies.openSans};
    border: 2px solid ${theme.colors.navyBlueSub1};
    &:hover {
      color: ${theme.colors.white};
      background: ${theme.colors.navyBlueSub1};
    }
    @media (min-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.fontSizes.p3};
    }
  `}
`;

export const SearchTypeBoutiqueCard = styled(Link)`
  display: flex;
  flex: 1;
  min-height: 332px;
  flex-direction: column;
  text-decoration: none;
  &:last-child {
    margin-right: 0;
  }
  ${({ theme }) => css`
    margin-right: ${theme.spacing(2)};
    @media (min-width: ${theme.breakpoints.sm}) {
      flex-wrap: nowrap;
      max-width: 100vw;
      overflow: hidden;
      display: flex;
      height: 100%;
    }
  `}
`;

export const SearchTypeImageBox = styled(Box)<{ $hasThumbnailUrl?: boolean }>`
  ${({ $hasThumbnailUrl, theme }) => css`
    width: 100%;
    min-height: 245px;
    position: relative;
    img {
      object-fit: cover;
    }
    ${theme.media.md.up} {
      max-width: 325px;
      min-height: 240px;
    }
    ${!$hasThumbnailUrl &&
    css`
      background: ${theme.colors.secondaryLightGrey};
      justify-content: center;
      display: flex;
    `}
  `}
`;

export const SearchTypeBoutiqueInfo = styled(Flex)`
  flex: 1;
  height: 100%;
  flex-direction: column;
  ${({ theme }) => css`
    margin-top: ${theme.spacing(2)};
  `}
`;

export const SearchTypeInfo = styled(Flex)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    text-align: left;
    font-weight: ${theme.fontWeights.regular};
    margin-bottom: 0;
    margin-top: ${theme.spacing(0.5)};
    line-height: ${theme.spacing(2.75)};
    color: ${theme.colors.black};
    font-family: ${theme.fontFamilies.openSans};
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.p2};
    }
  `}
`;

export const SearchTypePhoneInfo = styled(SearchTypeInfo)`
  text-transform: uppercase;
`;

export const SearchTypeTitle = styled(Box)`
  ${({ theme }) => css`
    font-size: ${theme.spacing(2.5)};
    text-align: left;
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
    line-height: ${theme.spacing(3)};
    color: ${theme.colors.almostBlack};
  `}
`;
